import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createSlots as _createSlots, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a47eda66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-container" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "text-center black__base__color" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, { gutter: 20 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 24,
          class: "app__header__title"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("program.events")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 24,
          class: "app__title mb-2"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("drawer.abstracts")), 1)
          ]),
          _: 1
        }),
        (_ctx.notSupport && !_ctx.notFound && !_ctx.loading)
          ? (_openBlock(), _createBlock(_component_el_col, {
              key: 0,
              span: 24
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("drawer.support")), 1),
                _createElementVNode("a", {
                  href: _ctx.eventData.value.abstractSettings.abstractImage,
                  target: "_blank"
                }, _toDisplayString(_ctx.$t("drawer.download")), 9, _hoisted_2)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.notFound && _ctx.pdfURL)
          ? (_openBlock(), _createBlock(_component_el_col, { key: 1 }, {
              default: _withCtx(() => [
                _createElementVNode("embed", {
                  src: `https://drive.google.com/viewerng/viewer?url=${_ctx.pdfURL}&embedded=true`,
                  class: _normalizeClass({ 'pdf-container': !_ctx.notFound })
                }, null, 10, _hoisted_3)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_skeleton, {
              style: {"width":"240px","margin":"0 auto"},
              loading: _ctx.loading,
              animated: ""
            }, _createSlots({
              template: _withCtx(() => [
                _createVNode(_component_el_skeleton_item, {
                  variant: "image",
                  style: {"width":"240px","height":"240px"}
                })
              ]),
              _: 2
            }, [
              (_ctx.notFound)
                ? {
                    name: "default",
                    fn: _withCtx(() => [
                      _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.$t("abstractsFound")), 1)
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["loading"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { class: "text-center mb-2 mt-2" }, {
          default: _withCtx(() => [
            (!_ctx.notFound && _ctx.validApply)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  class: "apply-button",
                  onClick: _ctx.goTo,
                  disabled: !_ctx.validApply
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("abstract.apply")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}